import type { ReactNode } from "react";
import classNames from "classnames";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface ToolbarIndicatorProps {
  children?: ReactNode;
  className?: string;
  danger?: boolean;
  disabled?: boolean;
  hideBackground?: boolean;
  label: string;
}

export const ToolbarIndicator = ({
  label,
  disabled = false,
  hideBackground = false,
  className = "",
  danger = false,
  children,
}: ToolbarIndicatorProps) => (
  <div
    className={classNames(
      "flex items-center gap-2 rounded-lg px-3",
      className,
      {
        "bg-[#2B2E33]": !hideBackground && !danger,
        "bg-[#e02f2f]/20": danger,
      },
    )}
  >
    <Typography.LabelXsPlus
      weight="medium"
      color={disabled ? "text-disabled" : "text-current"}
    >
      {label}
    </Typography.LabelXsPlus>
    {children}
  </div>
);
